import React, { Fragment } from 'react';
import moment from 'moment';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import iconTransform from 'src/helpers/iconTransform.js';

function WPControl(props) {
  const { label, value, origControlTypeName, increaseFontSize, helpText, align, icon, superScript = null } = props;

  //origControlTypeName to check for date field
  let finalValue = value && value !== '' && origControlTypeName === 'Date' ? moment(value).format('DD/MMM/YYYY') : value;
  const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';
  if (superScript === null) {
    return (
      <Fragment>
        <div className={`control-text flex-column ${alignClass}`}>
          {
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
              <div className={'control-icons-inline-controls fullWidth'}>
                <label className="readonly-label">
                  {transformDisplayText(label, DEFAULT_CONTROL_FONT_SIZES.WP, increaseFontSize)}
                  {helpText && <span>&nbsp;&nbsp;</span>}
                  {helpText && <InfoTooltip toolTipText={helpText} />}
                </label>
                <span className="readonly-content">{finalValue}</span>
              </div>
            </div>
          }
        </div>
      </Fragment>
    );
  }
  return (
    <Fragment>
      <div className={`display-flex control-superscript-container`}>
        <span className={'control-price-text'}>{transformDisplayText(label, DEFAULT_CONTROL_FONT_SIZES.WP, increaseFontSize)}</span>
        <div className={`display-flex flex-column center-align-superscript`}>
          <span className={'control-superscript-text'}>{superScript}</span>
          <span className={'control-price-superscript'}>{finalValue}</span>
        </div>
      </div>
    </Fragment>
  );
}

export default WPControl;



// WEBPACK FOOTER //
// ./src/ui/library/ContentParser/controls/WPControl/WPControl.js